import { styled } from '@mui/material/styles';
import { Box } from '@monorepo/nova-ui';

export const StyledCredentialsButton = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'disabled',
})<{ disabled?: boolean }>(({ theme, disabled }) => ({
  position: 'absolute',
  top: theme.spacing(-7),
  right: theme.spacing(2),
  backgroundColor: disabled
    ? theme.palette.action.disabled
    : theme.palette.secondaryInvert.main,
  borderRadius: theme.spacing(10),
  padding: theme.spacing(3),
  width: theme.spacing(12),
  height: theme.spacing(12),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: disabled ? 'not-allowed' : 'pointer',
  opacity: disabled ? 0.5 : 1,
  transition: 'transform 0.3s ease, opacity 0.2s ease',
  '&:hover': {
    transform: disabled ? 'none' : 'scale(1.1)',
  },
  '& svg': {
    fill: disabled ? theme.palette.text.disabled : theme.palette.common.white,
    stroke: disabled ? theme.palette.text.disabled : theme.palette.common.white,
  },
  [theme.breakpoints.down('md')]: {
    position: 'relative',
    top: 'auto',
    right: 'auto',
  },
}));
